import { z } from 'zod';
import { metadata } from '../content/helpers';

const articlePostSection = z.object({
  label: z.string(),
  href: z.string(),
});

const articlePostContentData = z.object({
  metadata,
  data: z.object({
    title: z.string(),
    short_description: z.string().optional(),
    content: z.string().optional(),
    sections: z.array(articlePostSection),
  }),
});

export const articlePostSchema = z.object({
  id: z.number().int().positive().optional(),
  name: z.string().min(1, 'Name is required').max(255),
  slug: z.string().optional().nullable(),
  image: z.string().optional().nullable(),
  author_id: z.number().int().positive().nullable().optional(),
  articles_category: z.array(z.object({ category_id: z.number().int().positive() })),
  content: z.object({
    en: articlePostContentData,
    es: articlePostContentData,
  }),
});

export type ArticleInput = z.infer<typeof articlePostSchema>;
